import { FilterDocumentTagMatchMode, FilterOptionKeys } from '@griply/types';
import { TFunction } from 'i18next';
import React from 'react';
import { TagEmpty16 as TagIcon } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  FilterOptionType,
  FilterSelectOption,
  TagMatchModeOption,
} from 'shared/types/filter';
import { Tag } from 'shared/types/tag';
import styled from 'styled-components';

const IconContainer = styled.span<{ $color: string }>`
  color: ${({ $color }) => $color ?? 'inherit'};
  line-height: 62.5%;
`;

export type Options = {
  t: TFunction;
  currentTagMatchMode?: FilterDocumentTagMatchMode;
};

export const createTagFilter = (
  tags: Tag[],
  { t, currentTagMatchMode = FilterDocumentTagMatchMode.Any }: Options,
): FilterSelectOption[] => {
  const tagMatchModeOptions: TagMatchModeOption[] = [
    {
      value: FilterDocumentTagMatchMode.Any,
      label: t('general.filters.tag.match-mode.any.label'),
      description: t('general.filters.tag.match-mode.any.description'),
    },
    {
      value: FilterDocumentTagMatchMode.All,
      label: t('general.filters.tag.match-mode.all.label'),
      description: t('general.filters.tag.match-mode.all.description'),
    },
    {
      value: FilterDocumentTagMatchMode.NoTag,
      label: t('general.filters.tag.match-mode.no-tag.label'),
      description: t('general.filters.tag.match-mode.no-tag.description'),
    },
  ];

  const isNoTagMode = currentTagMatchMode === FilterDocumentTagMatchMode.NoTag;

  return [
    {
      id: FilterOptionKeys.Tag,
      label: t('context-menus.filtering.task.filters.tags.title'),
      placeholder: t('general.labels.select'),
      icon: TagIcon,
      type: FilterOptionType.MultiSelect,
      selectOptions: isNoTagMode
        ? []
        : tags.map((tag) => ({
            label: tag.name,
            value: tag.id,
            start: (
              <IconContainer $color={tag.color}>
                <Icon icon={TagIcon} />
              </IconContainer>
            ),
          })),
      canReset: true,
      enableSearch: !isNoTagMode && !!tags.length,
      optionsAsButtons: true,
      noOptionsLabel: tags.length ? undefined : t('general.filters.tag.empty'),
      tagMatchMode: currentTagMatchMode,
      tagMatchModeOptions,
    },
  ];
};
